import { useEffect } from 'react';

declare global {
  interface Window {
    fbq: {
      (command: 'init', pixelId: string): void;
      (command: 'track', event: string, parameters?: Record<string, any>): void;
      loaded: boolean;
      version: string;
      queue: any[];
      callMethod: (...args: any[]) => void;
    };
    _fbq?: any;
    calendly?: any;
  }
}

const FacebookPixel = () => {
  useEffect(() => {
    // Initialize Facebook Pixel
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

    // Initialize your pixel
    window.fbq('init', '1351225592586555');
    window.fbq('track', 'PageView');
  }, []);

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: 'none' }}
        src="https://www.facebook.com/tr?id=1351225592586555&ev=PageView&noscript=1"
        alt=""
      />
    </noscript>
  );
};

export default FacebookPixel; 